// extracted by mini-css-extract-plugin
export default {"root":"RecentLoanCard_root__Pgfzj","iconTypography":"RecentLoanCard_iconTypography__8s4yt"};